<template>
    <div :class="clientWidth > 767 ? 'h-100' : ''">
        <div class="task-detail-body-header" v-if="clientWidth <= 767">
            <TabListHeader :tabs="tabs" :activeTab="activeTab" @changeTab="changeTab" :commentCounts="myCounts" />
        </div>
        <div :class="`bg-light-gray mt--15px taskdetail__leftright-wrapper ${clientWidth <= 767 ? '' : 'd-flex'}`">
            <div :class="`task-detail-leftside task__detail-padding ${clientWidth <= 767 ? activeTab === 'comment' ? 'task-detail-leftside-comment' : 'task-detail-leftside-allother' : ''}`"
                :style="{ 'width': (clientWidth > 767 ? 'calc(100% - 375px)' : '95%'), padding: clientWidth > 767 || ['comment', 'activity'].includes(activeTab) ? '' : '20px 18.5px' }">
                <div class="task-detail-body-title-area" v-if="activeTab === 'task-detail-tab' || clientWidth > 767">
                    <div class="task-detail-header-tags" v-if="!isSupport">
                        <ProjectTaskType
                            :id="'task_type_detail'"
                            :modelValue="taskTypeVal"
                            :options="projectData?.taskTypeCounts || []"
                            :disabled="checkPermission('task.task_type', projectData?.isGlobalPermission) !== true || task?.deletedStatusKey !== 0 || !canEditKpiTask"
                            @select="(val) => emit('update:taskType', val)"
                        >
                            <template #head>
                                <span class="task-header-tag task-header-tag-button">
                                    <img :src="taskTypeIcon" alt="" />
                                    <span>{{ $t('ProjectDetails.task_type') }}</span>
                                </span>
                            </template>
                        </ProjectTaskType>
                        <span class="task-header-tag">
                            <img :src="subTaskIcon" alt="" />
                            <span>{{ $t('ProjectDetails.subtask') }}</span>
                            <span class="task-header-tag-count">{{ subTasksArray.length }}</span>
                        </span>
                        <span class="task-header-tag">
                            <img :src="customFieldIcon" alt="" />
                            <span>{{ $t('CustomField.custom_field') }}</span>
                            <span class="task-header-tag-count">{{ customFieldCount }}</span>
                        </span>
                        <span class="task-header-tag">
                            <img :src="checklistIcon" alt="" />
                            <span>{{ $t('Checklist.checklist') }}</span>
                            <span class="task-header-tag-count">{{ task?.checklistArray?.length || 0 }}</span>
                        </span>
                        <span class="task-header-tag">
                            <img :src="attachmentIcon" alt="" />
                            <span>{{ $t('Attachments.attachments') }}</span>
                            <span class="task-header-tag-count">{{ task?.attachments?.length || 0 }}</span>
                        </span>
                    </div>
                    <TaskDetailTitle
                        :taskName="task.TaskName"
                        :task="task"
                        :isSupport="isSupport"
                        :taskType="task.TaskTypeKey"
                        :favourites="task.favouriteTasks"
                        :userId="userId"
                        :canEditKpiTask="canEditKpiTask"
                        @update:favourite="(val) => emit('update:favourite', val)"
                        @update:taskName="(val) => emit('update:taskName', val)"
                        @update:taskType="(val) => emit('update:taskType', val)"
                    />
                </div>
                <TaskDetailRightSide v-if="clientWidth > 767" :inlineLayout="true" :task="task" :parentTask="parentTask"
                    :taskStatusIndex="props.taskStatusIndex" :zIndexAssigne="props.zIndexAssigne"
                    :zIndexPriority="props.zIndexPriority" :zIndexEstimate="props.zIndexEstimate" :isSupport="isSupport" />
                <TaskDetailTab 
                    v-if="clientWidth > 767 || activeTab === 'task-detail-tab'" :task="task"
                    @openSeeAll="$emit('open', 'filesLinks')" :isSupport="isSupport" :subTasksArray="subTasksArray" :canEditKpiTask="canEditKpiTask" />

                <!-- Task Comments - sử dụng TaskComments component -->
                <TaskComments v-else-if="activeTab === 'comment' && Object.keys(projectData).length" :taskId="task._id"
                    :sprintId="task.sprintId" :creator="{ uid: task.Task_Leader, date: task?.createdAt }"
                    :parentTaskId="task?.ParentTaskId" :title="task?.TaskName" :folderId="task.folderObjId || null"
                    :userIds="commentUsers" :watchers="[...(task?.watchers || [])]"
                    :checklistArray="task?.checklistArray" :sprintName="task.sprintArray.name"
                    :folderName="task.sprintArray.folderName" :productData="{ customerId, productName }"
                    :forSupport="isSupport || isSupportProject" />

                <ActivityLog v-else-if="activeTab === 'activity' && !isSupport" :dataObj="task" :fromProject="false" />
                <TimeLog v-else-if="activeTab === 'time-log'" :task="task" />
                <TaskDetailRightSide v-if="clientWidth <= 767 ? activeTab === 'task-detail-tab' : false" :task="task"
                    :parentTask="parentTask" :taskStatusIndex="props.taskStatusIndex"
                    :zIndexAssigne="props.zIndexAssigne" :zIndexPriority="props.zIndexPriority"
                    :zIndexEstimate="props.zIndexEstimate" :isSupport="isSupport" />
            </div>
            <aside v-if="clientWidth > 767" class="task-detail-activity-panel">
                <div class="task-detail-side-tabs">
                    <button type="button" :class="{ active: rightPanelTab === 'comment' }" @click="rightPanelTab = 'comment'">
                        {{ $t('Comments.comments') }}
                        <span v-if="myCounts">{{ myCounts }}</span>
                    </button>
                    <button type="button" :class="{ active: rightPanelTab === 'activity' }" @click="rightPanelTab = 'activity'">
                        {{ $t('ProjectDetails.activity') }}
                    </button>
                    
                </div>
                <div class="task-detail-side-content">
                    <ActivityLog v-if="sidePanelReady && rightPanelTab === 'activity' && !isSupport" :dataObj="task" :fromProject="false" />
                    <TaskComments v-else-if="sidePanelReady && rightPanelTab === 'comment' && Object.keys(projectData).length" :taskId="task._id"
                        :sprintId="task.sprintId" :creator="{ uid: task.Task_Leader, date: task?.createdAt }"
                        :parentTaskId="task?.ParentTaskId" :title="task?.TaskName" :folderId="task.folderObjId || null"
                        :userIds="commentUsers" :watchers="[...(task?.watchers || [])]"
                        :checklistArray="task?.checklistArray" :sprintName="task.sprintArray.name"
                        :folderName="task.sprintArray.folderName" :productData="{ customerId, productName }"
                        :forSupport="isSupport || isSupportProject" />
                </div>
            </aside>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed, inject, onBeforeUnmount, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import TabListHeader from '@/components/molecules/TabListHeader/TabListHeader.vue'
import ProjectTaskType from '@/components/atom/TaskTypeSelection/TaskTypeSelection.vue'
import TaskDetailTitle from '@/components/molecules/TaskDetailTitle/TaskDetailTitle.vue'
import TaskDetailTab from '@/components/molecules/TaskDetailTab/TaskDetailTab.vue'
import TaskDetailRightSide from '@/components/organisms/TaskDetailRightSide/TaskDetailRightSide.vue'
import TaskComments from '@/views/Projects/Comments/Comments.vue'
import ActivityLog from '@/components/templates/ActivityLog/ActivityLog.vue'
import TimeLog from '@/views/TimeLog/TimeLog.vue'
import { useCustomComposable } from '@/composable';
import { canUserEditKpiTask } from '@/utils/kpiTaskPermissions';
import attachmentIcon from '@/assets/images/svg/task_image_svg.svg';
import checklistIcon from '@/assets/images/svg/check-list.svg';
import customFieldIcon from '@/assets/images/svg/custom_field_tour.svg';
import subTaskIcon from '@/assets/images/svg/sub-task.svg';
import taskTypeIcon from '@/assets/images/svg/check_gray.svg';

const { getters } = useStore();
const { checkPermission } = useCustomComposable();
const emit = defineEmits(['open', 'update:favourite', 'update:taskName', 'update:taskType']);

const props = defineProps({
    task: Object,
    clientWidth: Number,
    parentTask: Object,
    taskStatusIndex: {
        type: Number,
        default: 7
    },
    zIndexAssigne: {
        type: Number,
        default: 7
    },
    zIndexPriority: {
        type: Number,
        default: 7
    },
    zIndexEstimate: {
        type: Number,
        default: 7
    },
    isSupport: {
        type: Boolean,
        default: false
    },
    subTasksArray: {
        type: Array,
        default: () => []
    },
    userId: {
        type: String,
        default: ''
    }
});

const sprintData = computed(() => {
    let sprintData = false;
    if (projectData.value && props.task) {
        sprintData = props.task.folderObjId
            ? projectData.value?.sprintsfolders?.[props.task.folderObjId]?.sprintsObj?.[props.task.sprintId]
            : projectData.value?.sprintsObj?.[props.task.sprintId];
    }
    return sprintData || null;
});

const router = useRouter();
const route = useRoute();

watch(route, (newVal) => {
    activeTab.value = newVal.query.detailTab;
});

const projectData = inject("selectedProject");
const companyUsers = computed(() => getters["settings/companyUsers"] || []);
const users = computed(() => companyUsers.value?.map((x) => x.userId));
const canEditKpiTask = computed(() => canUserEditKpiTask(props.task, props.userId, companyUsers.value));

const activeTab = ref('');
const rightPanelTab = ref('comment');
const sidePanelReady = ref(false);
let sidePanelTimer = null;
const isSupportProject = computed(() => process.env.VUE_APP_SUPPORT_PROJECTID === projectData.value._id);

const customerId = ref(props.task?.customField?.[process.env.VUE_APP_CUSTOMFIELDID]?.fieldValue);
const productName = ref(props.task?.customField?.[process.env.VUE_APP_CUSTOMFIELDPRODUCTID]?.fieldValue);

onMounted(() => {
    if (!route.query?.detailTab) {
        router.replace({ query: { detailTab: "task-detail-tab" } });
    }
    activeTab.value = route.query.detailTab ? route.query.detailTab : 'task-detail-tab';

    sidePanelTimer = setTimeout(() => {
        sidePanelReady.value = true;
    }, 300);
});

onBeforeUnmount(() => {
    if (sidePanelTimer) {
        clearTimeout(sidePanelTimer);
        sidePanelTimer = null;
    }
});

const myCounts = computed(() =>
    getters["users/myCounts"]?.data?.[`task_${projectData.value._id}_${props.task.sprintId}_${props.task._id}_comments`] || 0
);
const taskTypeVal = computed(() => {
    return projectData.value?.taskTypeCounts?.find((x) => x.key === props.task?.TaskTypeKey) || {};
});
const customFieldCount = computed(() => {
    const task = props.task || {};
    const candidates = [
        task.customField,
        task.customFields,
        task.customFieldValues,
        task.customFieldArray,
        task.TaskCustomField,
        task.taskCustomField
    ];
    const fieldData = candidates.find((value) => Array.isArray(value) ? value.length : value && typeof value === 'object' && Object.keys(value).length);
    if (Array.isArray(fieldData)) return fieldData.length;
    if (fieldData && typeof fieldData === 'object') return Object.keys(fieldData).length;
    return 0;
});

const tabs = ref({
    ...(checkPermission('task.task_details', projectData.value?.isGlobalPermission) === true && {
        'task-detail-tab': {
            name: 'task_details',
            activeIcon: require('@/assets/images/svg/tab1Icon.svg'),
            inactiveIcon: require('@/assets/images/svg/tab1Icon.svg'),
        }
    }),
    ...(checkPermission('task.task_comment', projectData.value?.isGlobalPermission) === true && {
        'comment': {
            name: 'Comments',
            activeIcon: require('@/assets/images/svg/tab2Icon.svg'),
            inactiveIcon: require('@/assets/images/svg/tab2Icon.svg'),
        }
    }),
    ...(checkPermission('task.task_activity_log', projectData.value?.isGlobalPermission) === true && {
        'activity': {
            name: 'activity_log',
            activeIcon: require('@/assets/images/svg/tab3Icon.svg'),
            inactiveIcon: require('@/assets/images/svg/tab3Icon.svg'),
        }
    }),
    // 'time-log':{
    //     name: 'time_log',
    //     activeIcon:require('@/assets/images/svg/tab4Icon.svg'),
    //     inactiveIcon:require('@/assets/images/svg/tab4Icon.svg'),
    // }
});

const changeTab = (tab) => {
    activeTab.value = tab;
    router.replace({ ...route, query: { ...route.query, detailTab: tab } });
};

const commentUsers = computed(() => {
    let tmp = [];

    if (sprintData.value?.private) {
        tmp = Array.from(new Set([...(sprintData.value?.AssigneeUserId || []), ...(props.task.watchers || [])]));
    } else if (projectData.value?.isPrivateSpace) {
        tmp = [...(projectData.value?.AssigneeUserId || [])];
    } else {
        tmp = [...(users.value || [])];
    }
    return tmp;
});
</script>

<style src="./style.css"></style>
